<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <!-- Name -->
      <div>
        <label>Name</label>
        <div class="info" *ngIf="!update">Add descriptive name for the new rule. This helps when lots of rules have been created.</div>
        <div class="form-group mb-3">
          <input
            type="text"
            name="name"
            [(ngModel)]="name"
            class="form-control"
            [class.is-invalid]="!isValidName()"
            autocomplete="off"
            required
          />
        </div>
      </div>

      <!-- Selector -->
      <div>
        <label>Selector</label>
        <div *ngIf="labels == null">Loading...</div>
        <div class="info" *ngIf="!update && labels != null">
          The selector determines which group of users is included into the statistics.<br />
          Note that changing a label on a profile does not change the categorization of already existing statistics of that user.
        </div>
        <div class="warning" *ngIf="!update && labels?.length == 0">
          Currently there are no lables on profiles. Please add meanigful labels to users for categorization.
        </div>
        <div *ngIf="labels?.length > 0" class="form-group mb-3 input-group">
          <select class="form-select selector-key" name="label-key" [(ngModel)]="labelKey" [class.is-invalid]="labelKey == null" required>
            <option *ngFor="let l of labels" [value]="l.key">{{ l.key }}</option>
          </select>
          <span> = </span>
          <select
            class="form-select selector-value"
            name="label-value"
            [(ngModel)]="labelValue"
            [class.is-invalid]="labelValue == null"
            [disabled]="labelKey == null"
            required
          >
            <ng-container *ngIf="labelKey != null">
              <option *ngFor="let v of labelValues(labelKey)" [value]="v">{{ v }}</option>
            </ng-container>
          </select>
        </div>
      </div>

      <!-- Role -->
      <div>
        <label>Role</label>
        <div class="info" *ngIf="!update">
          All users with this role will have access to statistics of users that match the selector above.<br />
          Make sure you select a role here that is only available to certain users in management who should get insight into other users
          metrics. You can also apply the rule only to one specific management user instead.
        </div>
        <div class="form-group mb-3">
          <select class="form-select" name="role" [(ngModel)]="role" [class.is-invalid]="role == null">
            <option *ngIf="usernames != null" value="">[ Select a user ]</option>
            <option *ngFor="let r of roles" [value]="r.name">{{ r.name }}</option>
          </select>
        </div>
      </div>

      <!-- User -->
      <div *ngIf="role === ''">
        <label>User</label>
        <div class="form-group mb-3">
          <select class="form-select" name="user" [(ngModel)]="user" [class.is-invalid]="role === '' && user == null">
            <option *ngFor="let u of usernames" [value]="u">{{ u }}</option>
          </select>
        </div>
      </div>

      <div class="info" *ngIf="!update && f.form.valid && isValid()">
        You are about to create a new dashboard statistics rule that will affect
        <ng-container *ngIf="role !== ''">all users with the role <code>{{ role }}</code>.</ng-container>
        <ng-container *ngIf="role === '' && user != null">the user <code>{{ user }}</code>.</ng-container>
        <br />
        The {{ role !== '' ? 'users' : 'user' }} will have access only to statistics of users with the label
        <code>{{ labelKey }}={{ labelValue }}</code>.<br />
        If there are other rules that apply to the affected {{ role !== '' ? 'users' : 'user' }} then those will be included in the
        statistics as well.
      </div>

      <!-- Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!f.form.valid || !isValid()">Submit</button>
      </div>
    </div>
  </form>
</div>
